import { render, staticRenderFns } from "./RoleJurisdiction.vue?vue&type=template&id=9f371f2c&scoped=true&"
import script from "./RoleJurisdiction.vue?vue&type=script&lang=ts&"
export * from "./RoleJurisdiction.vue?vue&type=script&lang=ts&"
import style0 from "./RoleJurisdiction.vue?vue&type=style&index=0&id=9f371f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f371f2c",
  null
  
)

export default component.exports